const getProduct = (handle) => {
  let data = fetch(window.Shopify.routes.root + "products/" + handle + ".js")
    .then((response) => response.json())
    .then((res) => {
      return res;
    });
  return data;
};

let productData, quantity = 1;
const quantityEl = document.querySelector(".upsell-card__quantity");
const upsellCardAtc = document.querySelector(".upsell-card__atc");
const variantSelectEls = document.querySelectorAll(
  ".upsell-card__select select"
);
variantSelectEls.forEach((selectEl) => {
  selectEl.addEventListener("change", async () => {
    if (!productData) {
      productData = await getProduct(
        document
          .querySelector(".upsell-card__variants")
          .getAttribute("aria-product-handle")
      );
    }
    let selectedVariant = updateVarId(
      productData,
      getOptions(variantSelectEls)
    );
    upsellCardAtc.setAttribute("aria-variant-id", selectedVariant.id);
    updateUpsellData(selectedVariant);
  });
});

quantityEl.addEventListener('change', (e) => {
  quantity = e.target.value;
})

const updateUpsellData = (variant) => {
  const firstImage = document.querySelector(
    ".upsell-card__image img:first-child"
  );
  firstImage.setAttribute("src", variant.featured_image.src);
  firstImage.setAttribute("srcset", variant.featured_image.src);
};

const getOptions = (selectElements) => {
  let optionList = [];
  selectElements.forEach((selectEl) => {
    optionList.push(selectEl.value);
  });
  return optionList;
};

const updateVarId = (data, optionList) => {
  let selectedVariant,
    isMatch = true;
  data.variants.forEach((variant) => {
    optionList.every((option) => {
      isMatch = variant.options.indexOf(option) >= 0;
      return isMatch;
    });
    if (isMatch) selectedVariant = variant;
  });
  return selectedVariant;
};

const upsellCartDrawerUpdate = (sections) => {
  let cartDrawerEl = document.querySelector("#CartDrawer");
  let html = new DOMParser()
    .parseFromString(sections["cart-drawer"], "text/html")
    .querySelector("#CartDrawer").innerHTML;
  cartDrawerEl.innerHTML = html;
  let bubbleEl = document.querySelector("#cart-icon-bubble");
  bubbleEl.innerHTML = sections["cart-icon-bubble"];
};

upsellCardAtc.addEventListener("click", (e) => {
  const variantId = e.target.dataset.variantId
  e.target.innerHTML = "Adding...";
  $.ajax({
    type: "POST",
    url: "/cart/add",
    dataType: "json",
    data: {
      items: [
        {
          quantity: quantity,
          id: variantId,
          form_type: "product"
        },
      ],
      sections: "cart-drawer,cart-icon-bubble",
    },
    success: async function (res) {
      e.target.innerHTML = "Added";
      upsellCartDrawerUpdate(res.sections);
      setTimeout(() => {
        document
          .querySelector("#cartDrawerContainer")
          .classList.add("active");
      }, 500);
      e.target.removeAttribute("disabled", "");
    },
  }).fail(function (e) {
    console.log(e);
  });
});
